'use es6';

import { AD_NETWORK_FACEBOOK, AD_OBJECT_AD_GROUP } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { ADS_FACEBOOK_ADGROUPS } from 'reference-resolvers/constants/CacheKeys';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { createFetchAdsObjectSearchPageForNetwork, createFetchAdsObjectsByIdsForNetwork, fetchAdsObjectsByIdsForNetwork, fetchAdsObjectSearchPageForNetwork } from 'reference-resolvers/api/AdsEntityApi';
export const createAdsFacebookAdgroupsReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: ADS_FACEBOOK_ADGROUPS,
  createFetchByIds: opts => createFetchAdsObjectsByIdsForNetwork(opts)(AD_NETWORK_FACEBOOK, AD_OBJECT_AD_GROUP),
  createFetchSearchPage: opts => createFetchAdsObjectSearchPageForNetwork(opts)(AD_NETWORK_FACEBOOK, AD_OBJECT_AD_GROUP),
  fetchByIds: fetchAdsObjectsByIdsForNetwork(AD_NETWORK_FACEBOOK, AD_OBJECT_AD_GROUP),
  fetchSearchPage: fetchAdsObjectSearchPageForNetwork(AD_NETWORK_FACEBOOK, AD_OBJECT_AD_GROUP)
}, options));
export default createAdsFacebookAdgroupsReferenceResolver();